export const isColorLight = (color: string): boolean => {
    let r: number;
    let g: number;
    let b: number;

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If HEX --> store the red, green, blue values in separate variables
        const matches = color.match(
            /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*((\d+)?(?:\.\d+)?))?\)$/,
        );

        r = Number(matches[1]);
        g = Number(matches[2]);
        b = Number(matches[3]);
    } else {
        // If RGB --> Convert it to HEX: http://gist.github.com/983661
        const matches = +`0x${color.slice(1).replace(color.length < 5 && /./g, '$&$&')}`;

        // eslint-disable-next-line no-bitwise
        r = matches >> 16;
        // eslint-disable-next-line no-bitwise
        g = (matches >> 8) & 255;
        // eslint-disable-next-line no-bitwise
        b = matches & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    return hsp > 127.5;
};
